import { GlButton, GlTooltipDirective } from '@gitlab/ui';
import { __ } from '~/locale';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'PanelActions',
    components: {
        GlButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        maximizeUrl: {
            type: String,
            required: false,
            default: null
        }
    },
    i18n: {
        closePanelText: __('Close panel'),
        maximizePanelText: __('Open in full page')
    },
    emits: [
        'close',
        'maximize'
    ]
};
